import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { PaymentsPage } from "../../components/PaymentList";
import { api } from "../../lib/api";

export function DriverSelect({ value, onChange, testId = "driver-filter" }) {
  const [drivers, setDrivers] = useState([]);
  useEffect(() => { api.get("/users").then((r) => setDrivers(r.data)); }, []);
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Driver</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="h-10 w-48 bg-white" data-testid={testId}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Semua Driver</SelectItem>
          {drivers.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </label>
  );
}

export default function AdminPayments() {
  const [driverId, setDriverId] = useState("all");
  return (
    <PaymentsPage isAdmin driverId={driverId}>
      <DriverSelect value={driverId} onChange={setDriverId} />
    </PaymentsPage>
  );
}
